<div class="title" mat-dialog-title>Add Username & Password</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to contact your Sizmek Account Manager to obtain the details below</div>
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Sizmek Username</mat-label>
                <input matInput placeholder="Enter Sizmek Username" formControlName="username" data-cy="sizmek-username-input">
                <mat-error
                    *ngIf="connectionForm.get('username').errors && (connectionForm.get('username').touched || connectionForm.get('username').dirty)">
                    Invalid Username</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Sizmek Password</mat-label>
                <input type="password" matInput placeholder="Enter Sizmek Password" formControlName="password" data-cy="sizmek-password-input">
                <mat-error
                    *ngIf="connectionForm.get('password').errors && (connectionForm.get('password').touched || connectionForm.get('password').dirty)">
                    Invalid Password</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Sizmek Api Key</mat-label>
                <input type="password" matInput placeholder="Enter Sizmek Api Key" formControlName="apiKey" data-cy="sizmek-apikey-input">
                <mat-error
                    *ngIf="connectionForm.get('apiKey').errors && (connectionForm.get('apiKey').touched || connectionForm.get('apiKey').dirty)">
                    Invalid Api Key</mat-error>
            </mat-form-field>
        </form>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="sizmek-dialog-connect-btn">
            Connect Data Source
        </button>
    </div>
</div>